import { render, staticRenderFns } from "./poexitsurvey.vue?vue&type=template&id=3b36b666"
import script from "./poexitsurvey.vue?vue&type=script&lang=js"
export * from "./poexitsurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports